import React from "react";

import { Typography, Box } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";

import { costStyles } from "../styles/themeStyles";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

interface PredictedCostProps {
  pennies: number;
  variant?: Variant;
  hoursActive?: number;
  showLabel?: boolean;
}

// Calculate predicted monthly cost based on current pennies and time active
const calculatePredictedCost = (
  pennies: number,
  hoursActive: number = 24,
): number => {
  if (hoursActive <= 0) return 0;

  // Calculate pennies per hour based on current usage
  const penniesPerHour = pennies / hoursActive;

  // Project to a full month (30 days)
  const projectedMonthlyPennies = penniesPerHour * 24 * 30;

  return projectedMonthlyPennies;
};

const PredictedCost = ({
  pennies,
  hoursActive = 24,
  variant = "body1",
  showLabel = true,
}: PredictedCostProps) => {
  const predictedCost = calculatePredictedCost(pennies, hoursActive);
  const tooltipTitle = `Predicted monthly cost based on ${hoursActive} hours of activity`;

  return (
    <Box component="span" sx={{ display: 'inline-block' }}>
      <Typography variant={variant} title={tooltipTitle}>
        {showLabel ? "Predicted: " : ""}
        {formatter.format(predictedCost / 100)}
      </Typography>
    </Box>
  );
};

export default PredictedCost;